import styled from 'styled-components'

export const NewUserContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
`